(function () {
  'use strict';

  function getSettings() {
    return window.KINTSUGI_LP_SETTINGS || {};
  }

  function setImage(img, item) {
    if (!img || !item || !item.image) return;

    if (img.dataset.kintsugiManagedSrc === item.image) {
      return;
    }

    img.src = item.image;
    img.removeAttribute('srcset');
    img.dataset.kintsugiManagedSrc = item.image;

    if (item.alt) {
      img.alt = item.alt;
    }
  }

  function setText(el, value) {
    if (
      !el ||
      value === undefined ||
      value === null ||
      value === ''
    ) {
      return;
    }

    var text = String(value);

    if (el.textContent === text) {
      return;
    }

    el.textContent = text;
  }

  function normalizeLink(link) {
    if (!link || link === '#') {
      return '';
    }

    return link;
  }

  function applyProductSettings(sectionSelector, items) {
    if (!Array.isArray(items) || !items.length) {
      return;
    }

    var section = document.querySelector(sectionSelector);

    if (!section) {
      return;
    }

    var cards = Array.prototype.slice.call(
      section.querySelectorAll('article')
    );

    if (!cards.length) {
      return;
    }

    cards.forEach(function (card, cardIndex) {
      var itemIndex = cardIndex % 10;
      var item = items[itemIndex];

      if (!item) {
        return;
      }

      var imgs = card.querySelectorAll('img');

      imgs.forEach(function (img) {
        setImage(img, item);
      });

      setText(card.querySelector('h3'), item.name);

      var textRows = card.querySelectorAll('p');

      if (textRows.length) {
        setText(
          textRows[textRows.length - 1],
          item.price
        );
      }

      var href = normalizeLink(item.link);

      if (!href) {
        return;
      }

      card.dataset.kintsugiHref = href;
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      card.style.cursor = 'pointer';

      if (card.dataset.kintsugiLinkBound) {
        return;
      }

      card.addEventListener('click', function (event) {
        var interactive = event.target.closest(
          'a, button'
        );

        if (interactive) {
          return;
        }

        window.location.href =
          card.dataset.kintsugiHref;
      });

      card.addEventListener('keydown', function (event) {
        if (
          event.key === 'Enter' ||
          event.key === ' '
        ) {
          event.preventDefault();

          window.location.href =
            card.dataset.kintsugiHref;
        }
      });

      card.dataset.kintsugiLinkBound = 'true';
    });
  }

  function applyGalleryByAlt(prefix, items) {
    if (!Array.isArray(items) || !items.length) {
      return;
    }

    var escapedPrefix = prefix.replace(
      /[.*+?^${}()|[\]\\]/g,
      '\\$&'
    );

    var re = new RegExp(
      '^' + escapedPrefix + '\\s+(\\d+)$'
    );

    var images = Array.prototype.slice.call(
      document.querySelectorAll('img[alt]')
    );

    images.forEach(function (img) {
      var alt = String(
        img.getAttribute('alt') || ''
      );

      var match = alt.match(re);

      if (!match) {
        return;
      }

      var index = Number(match[1]) - 1;
      var item = items[index];

      if (!item) {
        return;
      }

      setImage(img, item);
    });
  }

  function applySettings() {
    var settings = getSettings();

    applyProductSettings(
      '#products',
      settings.kintsugiProducts
    );

    applyProductSettings(
      '#en-collection',
      settings.enProducts
    );

    applyGalleryByAlt(
      'Model photo',
      settings.styleGallery
    );

    applyGalleryByAlt(
      'KINTSUGI photo',
      settings.kintsugiGallery
    );
  }

  function start() {
    applySettings();

    window.setTimeout(applySettings, 250);
    window.setTimeout(applySettings, 1000);
    window.setTimeout(applySettings, 2000);

    var root =
      document.getElementById('kintsugi-root') ||
      document.body;

    if (
      root &&
      window.MutationObserver
    ) {
      var timer = null;

      var observer = new MutationObserver(function () {
        window.clearTimeout(timer);

        timer = window.setTimeout(
          applySettings,
          60
        );
      });

      observer.observe(root, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();